import styled from 'styled-components';

import { listingRichTextStyles } from './listingRichTextStyles';

export const ListingRichTextHolder = styled.div`
  word-break: break-word;
  ${listingRichTextStyles};
`;
